// extracted by mini-css-extract-plugin
export default {"sec":"Banner_sec__0Gu2Q","overlayDiv":"Banner_overlayDiv__2waKu","h2":"Banner_h2__lkHiF","p":"Banner_p__WQqHl","bgImg":"Banner_bgImg__KDjf0"};